import store from '@/store'
import { i18n } from '@/locale'
import { LocalizedText } from '@/entities/LocalizedText'
import snakecaseKeys from 'snakecase-keys'
function getTextValue (localizedTexts) {
  var value = null
  var defaultLanguageCode = store.state.me.facility.defaultLanguageCode
  var localizedArray = snakecaseKeys(localizedTexts).map((text) => new LocalizedText(text))
  const configuredLocale = localizedArray.find((text) => { return text.languageCode === i18n.locale })
  if (configuredLocale) {
    value = configuredLocale.value
  } else {
    const defaultLocale = localizedArray.find((text) => { return text.languageCode === defaultLanguageCode })
    value = defaultLocale ? defaultLocale.value : null
  }
  return value
}

export {
  getTextValue,
}
